import store from "../store/configureStore";
import axios from "axios";
import { partnerTypeIdVar } from "variables";
import { whenSignalRReady } from "../providers/NotificationProvider";
import i18next from "i18next";

export function getToken() {
  if (store.getState().oidc.user) {
    return store.getState().oidc.user.access_token;
  }

  if (sessionStorage.getItem("access_token")) {
    return sessionStorage.getItem("access_token");
  }
  return "";
}

function getHeaders() {
  const token = getToken();
  const language = i18next.language;
  const partnerTypeId = partnerTypeIdVar();

  return {
    //"Accept": "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    "Accept-Language": `${language}`,
    "MasterPartner-PartnerTypeId": `${partnerTypeId}`
  };
}

function internalRequest(url, options) {
  return axios
    .request(url, options)
    .then(res => res.data)
    .catch(function (error) {
      if (error.response && error.response.data) {
        throw (
          {
            ...error.response.data,
            message:
              error.response.data.detail ||
              (error.response.data.title === "Forbidden" ? i18next.t("Forbidden") : error.response.data.title)
          } || error
        );
      }
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      throw error;
    });
}

export async function post(url, data) {
  const options = {
    method: "post",
    data: JSON.stringify(data),
    headers: getHeaders()
  };

  let prom = whenSignalRReady();
  if (prom) {
    await prom;
  }

  return internalRequest(url, options);
}

export async function put(url, data) {
  const options = {
    method: "put",
    data: JSON.stringify(data),
    headers: getHeaders()
  };

  let prom = whenSignalRReady();
  if (prom) {
    await prom;
  }
  return internalRequest(url, options);
}

export async function del(url, data) {
  const options = {
    method: "delete",
    data: JSON.stringify(data),
    headers: getHeaders()
  };

  let prom = whenSignalRReady();
  if (prom) {
    await prom;
  }
  return internalRequest(url, options);
}

export async function upload(url, formData, progressCallback) {
  let prom = whenSignalRReady();
  if (prom) {
    await prom;
  }

  const options = {
    method: "put",
    onUploadProgress: function (progressEvent) {
      if (progressCallback) progressCallback(Math.round((progressEvent.loaded * 100) / progressEvent.total));
    },
    headers: getHeaders()
  };

  options.data = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    options.data.append(key, value);
  });

  return internalRequest(url, options);
}

export function get(url) {
  const options = {
    method: "GET",
    headers: getHeaders()
  };
  return internalRequest(url, options);
}
